import { Controller } from "@hotwired/stimulus";

function parseHex(value) {
  const clean = (value || "").replace(/^#/, "");
  return /^[0-9a-fA-F]{6}$/.test(clean) ? clean : null;
}

function parseFontSize(value) {
  const n = parseInt(value, 10);
  return n >= 8 && n <= 72 ? n : null;
}

export default class extends Controller {
  static targets = ["bg", "text", "fontSize", "showIcons", "fade", "preview", "iframe"];
  static values = { baseUrl: String };

  connect() {
    this.rebuild();
  }

  rebuild() {
    const params = new URLSearchParams();

    const bg = parseHex(this.bgTarget.value);
    if (bg) params.set("bg", bg);

    const text = parseHex(this.textTarget.value);
    if (text) params.set("text", text);

    const fs = parseFontSize(this.fontSizeTarget.value);
    if (fs !== null) params.set("font_size", fs);

    if (!this.showIconsTarget.checked) params.set("show_platform_icons", "0");
    if (!this.fadeTarget.checked) params.set("fade", "0");

    const qs = params.toString();
    const url = qs ? `${this.baseUrlValue}&${qs}` : this.baseUrlValue;
    this.previewTarget.value = url;
    if (this.hasIframeTarget) this.iframeTarget.src = url;
  }
}
